import { useMatch } from 'react-router'
import {
  getGraphQLErrorCode,
  isTerminalGraphQLError,
  shouldRetryGraphQLRequest,
} from '../client'
import { useGetGameBySlugQuery } from '../generated/graphql'

const useCurrentGameRoute = () => {
  const matchedNestedGameRoute = useMatch('/games/:slug/*')
  const matchedBaseGameRoute = useMatch('/games/:slug')
  const matchedGameRoute = matchedNestedGameRoute || matchedBaseGameRoute
  const slug = matchedGameRoute?.params.slug
  // Failed queries hold no data, so re-fires would flip back to loading forever; terminal errors must stick.
  const { data, error, isLoading } = useGetGameBySlugQuery(
    { slug: slug || '' },
    {
      enabled: Boolean(slug),
      retry: shouldRetryGraphQLRequest,
      retryOnMount: false,
      refetchOnWindowFocus: (query) =>
        !isTerminalGraphQLError(query.state.error),
      refetchOnReconnect: (query) => !isTerminalGraphQLError(query.state.error),
    }
  )

  const errorCode = getGraphQLErrorCode(error)
  const isNotAllowed = errorCode === '401' || errorCode === '403'
  const isNotFound = errorCode === '404'

  return {
    game: data?.getGameBySlug,
    isGameRoute: Boolean(matchedGameRoute),
    isLoading,
    isNotAllowed,
    isNotFound,
    shouldHideGameChrome:
      Boolean(slug) && (isLoading || isNotFound || isNotAllowed),
    slug,
  }
}

export default useCurrentGameRoute
